const DebtAcknowledgement = () => {
  return (
    <div className="w-full p-6">
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <h1 className="text-2xl font-bold text-gray-900 uppercase">
          Debt Acknowledgement and Loan Agreement
        </h1>

        <p>
          This Agreement is made between <strong>Helacred</strong>{" "}
          ("the Company") Helacred BOX 41-EMBU CODE 00605 with
          registered offices at JM Plaza 3rd floor, and the undersigned Borrower
          ("the Borrower").
        </p>

        {/* PART A */}
        <h2 className="text-xl font-semibold text-gray-900">
          Part A: Borrower&apos;s Details
        </h2>
        <div className="space-y-2">
          <p>Borrower&apos;s Name: __________________________</p>
          <p>ID Number: __________________________</p>
          <p>P.O. Box: __________________________</p>
          <p>Personal Email: __________________________</p>
          <p>Phone Number: __________________________</p>
          <p>Residence: __________________________</p>
          <p>Work Station: __________________________</p>
        </div>

        {/* PART B */}
        <h2 className="text-xl font-semibold text-gray-900">
          Part B: Loan Details and Repayment Undertaking
        </h2>
        <ol className="list-decimal list-inside space-y-3">
          <li>
            <strong>Loan Amount:</strong> I hereby acknowledge being indebted to
            Helacred for a loan amounting to the tune of Kenya
            Shillings [Loan Amount in Words] (Kshs. [Loan Amount in Figures]).
          </li>
          <li>
            <strong>Repayment Obligation:</strong> I agree and undertake to
            repay the total debt plus interest in the sum of Kenya Shillings
            [Total Repayable Amount in Words] (Kshs. [Total Repayable Amount in
            Figures]) on or before [Repayment Due Date].
          </li>
          <li>
            <strong>Employment Confirmation:</strong> I confirm that I am an
            employee of [Employer&apos;s Name] and authorize Helacred
            to contact my employer, including my HR/Payroll contact person, to
            verify my employment details.
          </li>
          <li>
            <strong>Penalty Clause:</strong> I agree that failure to repay the
            loan plus the interest amount on or before the stipulated timeline
            shall attract an applicable interest rate of 20% per month on the
            principal amount/balance unpaid. I will also incur a debt recovery
            fee of Ksh10,000 and a penalty of 3% of the loan amount for each day
            of default.
          </li>
          <li>
            <strong>Debt Recovery Costs:</strong> I undertake to incur all costs
            related to debt recovery and any administration fees as the said
            Lender deems necessary.
          </li>
          <li>
            <strong>Loan Processing Fee:</strong> The borrower shall pay a
            further Kenya Shillings 6% of the loan amount at the time of loan
            application if they are a new customer borrowing above Ksh 30,000.
            Existing customers will pay Ksh 1,400 for loans above Ksh 10,000 and
            Ksh 800 for loans below Ksh 10,000 per application. First-time
            customers borrowing less than Ksh 30,000 shall pay fees applicable
            to existing borrowers.
          </li>
        </ol>

        {/* PART C */}
        <h2 className="text-xl font-semibold text-gray-900">
          Part C: Affidavit and Asset Agreement
        </h2>
        <ol className="list-decimal list-inside space-y-3">
          <li>
            <strong>Sworn Statement:</strong> I, [Borrower&apos;s Name], of ID
            No. [ID Number], in the Republic of Kenya, do make oath and state
            that Helacred has agreed to extend a loan to me.
          </li>
          <li>
            <strong>Irrevocable Rights:</strong> I irrevocably assign all
            rights, title, and interest in the assets contained in the Asset
            Schedule and/or any other asset attachable in my premises. I
            authorize Helacred and its agents, without requirement for
            any prior notice, to immediately enter upon my land or premises,
            take possession of and dispose of by public auction or any other
            method the Company deems workable all properties seized.
          </li>
        </ol>

        {/* PART D */}
        <h2 className="text-xl font-semibold text-gray-900">
          Part D: Guarantor&apos;s Undertaking
        </h2>
        <div className="space-y-2">
          <p>
            <strong>Guarantor&apos;s Details:</strong>
          </p>
          <p>Name: __________________________</p>
          <p>ID Number: __________________________</p>
          <p>Phone Number: __________________________</p>
          <p>Work Station: __________________________</p>
          <p>Residence: __________________________</p>
        </div>
        <p>
          <strong>Guarantor&apos;s Undertaking:</strong> I do hereby bind myself
          to guarantee the full payment of the debt and interest and in case of
          default by the principal borrower, I agree and undertake to repay the
          debt myself as a guarantor and to the same degree of liability on a
          joint and several basis as the principal debtor.
        </p>

        {/* PART E */}
        <h2 className="text-xl font-semibold text-gray-900">
          Part E: Official Signatures
        </h2>
        <div className="space-y-4">
          <p>
            Sworn by the said Borrower <br />
            Name: __________________________
          </p>
          <p>
            Signature: __________________________ <br />
            Date: __________________________
          </p>
          <p>
            Witness/Advocate: __________________________ <br />
            Signature &amp; Stamp: __________________________
          </p>
          <p>
            Guarantor&apos;s Name: __________________________ <br />
            Signature: __________________________ <br />
            Date: __________________________
          </p>
        </div>
      </div>
    </div>
  );
};

export default DebtAcknowledgement;
